import serviceBase from '@/services/serviceBase'

class produtoService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    buscarCategorias() {
        return this.get(`${ this.getSubdominio() }/categoria-de-produto`)
    }
}

export default new produtoService()